import React from 'react';
import { motion } from 'framer-motion';
import './DepartmentCTA.css';
import { Link } from 'react-router-dom';
 
const MotionLink = motion(Link);
const DepartmentCTA = ({ 
  title, 
  subtitle, 
  primaryButton, 
  secondaryButton,
  backgroundImage,
  overlayColor = 'rgba(0, 40, 80, 0.85)',
  badge,
  formationLink // Nouvelle prop
}) => {
  const sectionStyle = backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  } : {};

 

  return (
    <section className="department-cta" style={sectionStyle}>
      <div className="department-cta-overlay" style={{ backgroundColor: overlayColor }}></div>
      
      <div className="cta-particles">
        <span></span><span></span><span></span><span></span>
        <span></span><span></span><span></span><span></span>
      </div>

      <div className="container">
        <motion.div
          className="department-cta-content"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          viewport={{ once: true }}
        >
          {badge && (
            <motion.div 
              className="cta-badge"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              {badge}
            </motion.div>
          )}

          <motion.h2
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {title}
          </motion.h2>

          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            {subtitle}
          </motion.h3>

          <motion.div 
            className="cta-buttons"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            {primaryButton && (
              <MotionLink
                to={primaryButton.link}
                className="btn-cta-primary"
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.97 }}
                transition={{ duration: 0.2 }}
              >
                {primaryButton.label}
                <span className="btn-glow-effect"></span>
              </MotionLink>
            )}
            {secondaryButton && (
              <motion.a 
                href={formationLink || secondaryButton.link}  
                className="btn-cta-secondary"
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.97 }}
                transition={{ duration: 0.2 }}
              >
                {secondaryButton.label}
              </motion.a>
            )}
          </motion.div>

          {/* Étoile filante - identique à celle du Hero */}
          <div className="cta-star-wrapper">
            <div className="cta-star-line"></div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DepartmentCTA;